import { c as _c } from "react/compiler-runtime";
import ListOptionsBar from '@/components/modules/ListOptionsBar';
import useReviewsHasFilters from '../context/useReviewsHasFilters';
import ReviewsFilters from './ReviewsFilters';
import ReviewsOrder from './ReviewsOrder';
import { FFormIdEnum } from '@/types/form';
const ReviewsListOptions = () => {
    const $ = _c(5);
    const { hasFilters } = useReviewsHasFilters();
    let t0;
    if ($[0] !== hasFilters) {
        t0 = hasFilters ? <ReviewsFilters formId={FFormIdEnum.REVIEW_LIST_OPTIONS}/> : null;
        $[0] = hasFilters;
        $[1] = t0;
    }
    else {
        t0 = $[1];
    }
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = <ReviewsOrder formId={FFormIdEnum.REVIEW_LIST_OPTIONS}/>;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    let t2;
    if ($[3] !== t0) {
        t2 = <ListOptionsBar filterButtons={t0} orderSelect={t1} showFiltersIntro={true}/>;
        $[3] = t0;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    return t2;
};
export default ReviewsListOptions;
